import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveModalAction } from '../actions';
import { fromStore } from '../selectors';

export function CityIcon() {
  const dispatch = useDispatch();
  const selected = useSelector(fromStore.selectedCitySelector);

  const openCityModal = () => {
    dispatch(setActiveModalAction({ field: 'city', value: true }));
  };

  if (!selected) return null;

  return (
    <div className="d-flex align-items-center ms-1 ms-lg-2">
      <div aria-hidden onClick={openCityModal} className="btn btn-icon-muted btn-active-light btn-active-color-dark cursor-pointer">
        <span className="svg-icon svg-icon-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path opacity="0.3" d="M18.0624 15.3454L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3454C4.56242 13.6454 3.76242 11.4452 4.06242 8.94525C4.56242 5.34525 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24525 19.9624 9.94525C20.0624 12.0452 19.2624 13.9454 18.0624 15.3454ZM13.0624 10.0453C13.0624 9.44534 12.6624 9.04534 12.0624 9.04534C11.4624 9.04534 11.0624 9.44534 11.0624 10.0453V13.0453H13.0624V10.0453Z" fill="currentColor" />
            <path d="M12.6624 5.54531C12.2624 5.24531 11.7624 5.24531 11.4624 5.54531L8.06241 8.04531V12.0453C8.06241 12.6453 8.46241 13.0453 9.06241 13.0453H11.0624V10.0453C11.0624 9.44531 11.4624 9.04531 12.0624 9.04531C12.6624 9.04531 13.0624 9.44531 13.0624 10.0453V13.0453H15.0624C15.6624 13.0453 16.0624 12.6453 16.0624 12.0453V8.04531L12.6624 5.54531Z" fill="currentColor" />
          </svg>
        </span>
        {selected.name}
      </div>
    </div>
  );
}
